import { includesFactory } from './src/includesFactory';
import { fixModelFactory } from './src/fixModelFactory';

/**
 * Mergea las dependencias en los campos de tipo "include" (solo "include" de momento)
 * /!\ Esta función modifica el view original /!\
 *
 * @param {object} dependencies {filename: file} lista de ficheros que pueden ser .view o .in4 de momento
 * @return {object} el view actualizado con sus dependencias
 */

export function mapIncludesFactory(dependencies) {
  if (typeof dependencies !== 'object' || !Object.keys(dependencies).length) {
    return p => p;
  }

  let model; /** sera "CAB" o "form" pero aun no podemos saberlo */
  const findViewFieldDependency = includesFactory(dependencies);

  return property => {
    if (!model && property?.model) {
      /** intentamos inicializar lo mas pronto posible con la base, ej "CAB", luego sera fijo */
      model = property.model.split('.')[0];
    }

    const fixModel = fixModelFactory(property?.model ?? model);

    if (!Array.isArray(property?.properties)) {
      return property;
    }

    let queue = [...property.properties];
    property.properties = [];

    while (queue.length) {
      const viewField = queue.shift();

      if (viewField.type !== 'include') {
        property.properties.push(viewField);
      } else {
        try {
          const found = findViewFieldDependency(viewField);
          const cloned = JSON.parse(JSON.stringify(found));
          const viewFieldDependency = fixModel(cloned);
          /**
           * insertamos al inicio de la cola los nuevos campos
           * si tipo properties, se insertan los hijos del campo de la dependencia
           * sino se inserta el campos de la dependencia tal cual
           */
          if (viewField?.metadata?.type === 'properties') {
            // insertamos los hijos
            queue = [...viewFieldDependency.properties, ...queue];
          } else {
            // insertamos el campo: el property de la dependencia => se inserta el campo (con sus properties)
            queue = [viewFieldDependency, ...queue];
          }
        } catch (e) {
          console.warn(e);
        }
      }
    }

    return property;
  };
}
